<button mat-menu-item (click)="preview()">
  <span>{{ 'ProjectContacts.List.preview' | translate }}</span>
</button>

<button
  mat-menu-item
  *ngIf="row?.id !== projectPreviewService?.project?.MainContact?.id && row?.id !== projectPreviewService?.project?.basicDataBox?.responsibleContact?.id"
  (click)="markAsClient()">
  <span>{{ 'ProjectContacts.List.markAsClient' | translate }}</span>
</button>

<button
  mat-menu-item
  *ngIf="row?.id !== projectPreviewService?.project?.basicDataBox?.responsibleContact?.id && row?.id !== projectPreviewService?.project?.MainContact?.id"
  (click)="markAsResponsibleClient()">
  <span>{{ 'ProjectContacts.List.markAsResponsibleClient' | translate }}</span>
</button>

<button
  mat-menu-item
  *ngIf="!row?.employee"
  (click)="createAccount()">
  <span>{{ 'ProjectContacts.List.createAccount' | translate }}</span>
</button>

<button
  mat-menu-item
  *ngIf="row?.employee || row?.email"
  (click)="createTask()">
  <span>{{ 'ProjectContacts.List.createTask' | translate }}</span>
</button>

<button *ngIf="!row?.deleted" mat-menu-item (click)="removeFromProject()" class="hover_red red-500">
  <span>{{ 'ProjectTeam.List.removeFromProject' | translate }}</span>
</button>
